export default __webpack_public_path__ + "locales/pt-BR/About.json?hash=167cda6e38b9271c5c2c3372ebe3c32b";